import Vue from 'vue';
import moment from 'moment';
import VueMoment from 'vue-moment';

// eslint-disable-next-line import/no-unassigned-import
import 'moment/locale/en-gb';

Vue.use(VueMoment, { moment });
